import axios from './axios';

export const getSupplierItems = ({ params } = {}) => axios.get(`supplier-items`, { params });
export const getSupplierItemsBySupplier = ({ supplierId, params }) => axios.get(`suppliers/${supplierId}/items`, { params });
export const getSupplierItem = ({ id, params }) => axios.get(`supplier-items/${id}`, { params });
export const createSupplierItem = ({ data }) => axios.post('supplier-items', data);
export const updateSupplierItem = ({ id, data }) => axios.put(`supplier-items/${id}`, data);
export const deleteSupplierItem = ({ id }) => axios.delete(`supplier-items/${id}`);
export const toggleSupplierItemActive = ({ id }) => axios.patch(`supplier-items/${id}/toggle-active`);
export const getSupplierItemCostHistory = ({ id }) => axios.get(`supplier-items/${id}/cost-history`);
export const syncSupplierItemPaintList = ({ id, data }) => axios.post(`supplier-items/${id}/sync-paint-list`, data);
